import { Stack, usePathname } from 'expo-router';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { useDeeplinksFlowExperiment } from 'experiments/deeplinks-flow-feature/use-deeplinks-flow-experiment';
import { useEnableNativeTabBarExperiment } from 'experiments/use-enable-native-tab-bar-experiment';
import { isOfferItemRoute } from 'navigation/routing/utils';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants';
import { routes } from 'utils/routing';

export default function OffersLayout() {
  const { isTreatment: isNativeTabBarEnabled } = useEnableNativeTabBarExperiment();
  const {
    isEnabled: isDeeplinksFlowEnabled,
    isLoading: isExperimentLoading,
  } = useDeeplinksFlowExperiment();
  const pathname = usePathname();
  const requireStore =
    Boolean(useFlag(LaunchDarklyFlag.FORCE_RESTAURANT_SELECTION_FOR_REWARDS)) &&
    !(isOfferItemRoute(pathname) && (isExperimentLoading || isDeeplinksFlowEnabled));

  useStoreRequired(requireStore, undefined, routes.offers);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          header: () => (
            <StandardMobileHeader useNativeTabsRootSafeAreaInset={isNativeTabBarEnabled} />
          ),
          headerShown: true,
        }}
      />
      {/* NOTE: modals are in (modals) */}
    </Stack>
  );
}
